// eslint-disable-next-line import/no-cycle
import {
  WidgetTypeConfig,
  ConfigurationPanelStructureItemEnum,
  LinkTypeEnum,
  ComponentNameEnum,
  AlignValueEnum,
  ElementPartTypeEnum,
  TemplateStructureEnum,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import getHorizontalSpacesFieldConfig from '@/components/template-builder/config/fields/horizontal-spaces-config';
// eslint-disable-next-line import/no-cycle
import getVerticalSpacesFieldConfig from '@/components/template-builder/config/fields/vertical-spaces-config';
// eslint-disable-next-line import/no-cycle
import imageFieldConfig from '@/components/template-builder/config/fields/image-config';
// eslint-disable-next-line import/no-cycle
import getElementAlignFieldConfig from '@/components/template-builder/config/fields/element-align-config';
// eslint-disable-next-line import/no-cycle
import getWidthFieldConfig from '@/components/template-builder/config/fields/width-config';
// eslint-disable-next-line import/no-cycle
import variables from '@/components/template-builder/utils/variables-list';
// eslint-disable-next-line import/no-cycle
import {
  setLink,
  setAttribute,
  setCssProperty,
  setMediaDisplay,
  setCssPropertyAndRemoveIfZero,
  toggleClass,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getAttributeByName,
  getClassByName,
  getCssPropertyByName,
  getLinkType,
  hasClass,
  isMediaDisplayAlreadyRestricted,
} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import getLinkFieldConfig from '@/components/template-builder/config/fields/link-config';
// eslint-disable-next-line import/no-cycle
import getColorFieldConfig from '@/components/template-builder/config/fields/color-config';
// eslint-disable-next-line import/no-cycle
import bordersFieldConfig from '@/components/template-builder/config/fields/borders-config';
// eslint-disable-next-line import/no-cycle
import mediaDisplayFieldConfig from '@/components/template-builder/config/fields/media-display-config';
// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '@/components/template-builder/utils/helpers';
// eslint-disable-next-line import/no-cycle
import { HIDE_MOBILE_ATTRIBUTE } from '@/components/template-builder/utils/constants';
// eslint-disable-next-line import/no-cycle
import getDisplayFieldConfig from '@/components/template-builder/config/fields/display-config';
// eslint-disable-next-line import/no-cycle
import getConditionsAndRepetitionGroup from '@/components/template-builder/config/fields/conditions-repetition-group-helper';
// eslint-disable-next-line import/no-cycle
import getWidgetCommonStylesGroup from '@/components/template-builder/config/fields/widget-common-styles-config';

const linkOptions = [LinkTypeEnum.NONE, LinkTypeEnum.WEB_ADDRESS, LinkTypeEnum.EMAIL_ADDRESS, LinkTypeEnum.ANCHOR];
// if (isDisplayTemplate(templateType)) linkOptions.push(LinkTypeEnum.DISPLAY_TEMPLATE);

const emailWidgetImageConfig: WidgetTypeConfig = {
  tabPanel: {
    label: 'templateBuilder.widgetsHeaders.image',
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.widgetConfiguration',
        selector: 'body #spm_body #{ID}',
        items: [
          {
            label: 'templateBuilder.fields.image',
            selector: '{SELECTOR} > tbody > tr > th img',
            properties: [
              { name: 'src', getter: getAttributeByName, setters: [setAttribute] },
              { name: 'alt', getter: getAttributeByName, setters: [setAttribute] },
            ],
            ...imageFieldConfig,
            options: {
              ...imageFieldConfig.options,
              description: true,
            },
          },
          {
            label: 'templateBuilder.fields.link',
            selector: '{SELECTOR} > tbody > tr > th',
            properties: [{ name: 'href', getter: getLinkType, setters: [setLink] }],
            ...getLinkFieldConfig(LinkTypeEnum.NONE, linkOptions, variables.allVariables),
          },
        ],
      },
      {
        type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
        tabItemType: TemplateStructureEnum.GROUP,
        label: 'templateBuilder.configs.widgetStyles',
        canSave: true,
        elementPartType: ElementPartTypeEnum.STYLES,
        tabPanel: {
          items: [
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.widgetBlockStyles',
              selector: 'body #spm_body #{ID}',
              items: [
                {
                  label: 'templateBuilder.fields.width',
                  selector: '{SELECTOR} > tbody > tr > th img',
                  properties: [{ name: 'max-width', getter: getCssPropertyByName, setters: [setCssProperty] }],
                  fieldId: 'imgWidth',
                  ...getWidthFieldConfig(),
                },
                {
                  label: 'templateBuilder.fields.displayFullWidthMobile',
                  selector: '{SELECTOR} > tbody > tr > th img',
                  properties: [{ name: 'spm_display_fullwidth_mobile', getter: hasClass, setters: [toggleClass] }],
                  displayToggle: false,
                  parentFieldId: 'imgWidth',
                  isVisible: (items: any[], parentFieldId: string) => {
                    const property = items.find((item) => item.fieldId === parentFieldId);
                    if (property && Array.isArray(property.properties) && property.properties.length && property.properties[0].value !== '100%') {
                      return true;
                    }
                    return false;
                  },
                  disableHandler: () => getTemplateIframeDocument()?.body.getAttribute(HIDE_MOBILE_ATTRIBUTE) === 'true',
                  disableMessage: 'templateBuilder.fields.warningMessages.disabledMobileDesign',
                  ...getDisplayFieldConfig('spm_display_fullwidth_mobile', ''),
                },
                {
                  label: 'templateBuilder.fields.alignment',
                  selector: '{SELECTOR} > tbody > tr > th',
                  properties: [{ name: 'text-align', getter: getCssPropertyByName, setters: [setCssProperty] }],
                  ...getElementAlignFieldConfig('text-align', AlignValueEnum.CENTER),
                },
                {
                  label: 'templateBuilder.fields.borders',
                  selector: '{SELECTOR}.spm_widget_image, {SELECTOR}.spm_widget_display_image',
                  properties: [
                    { name: 'border-color', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-style', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-width', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
                    { name: 'border-bottom-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-bottom-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-bottom-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-top-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-top-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-top-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-left-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-left-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-left-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-right-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-right-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-right-width', getter: getCssPropertyByName, setters: [] },
                  ],
                  ...bordersFieldConfig,
                },
              ],
            },
            getWidgetCommonStylesGroup('{SELECTOR} > tbody > tr > th'),
          ],
        },
      },
      getConditionsAndRepetitionGroup('body #spm_body #{ID}'),
    ],
  },
};

export default emailWidgetImageConfig;
